/**
 *  @fileOverview Main file to initialise JS. Import all code as modules here
 *
 *  @author       Chris Hill
 *
 *  @requires     NPM:@babel/polyfill
 */

import '../scss/main.scss'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faAngleDoubleDown, faAngleDoubleLeft, faAngleDoubleRight, faAngleDoubleUp, faAngleDown, faAngleLeft, faAngleRight, faAngleUp, faArrowDown, faArrowLeft, faArrowRight, faArrowUp, faBars, faBell, faBook, faBookmark, faBookOpen, faBriefcase, faBuilding, faCalendar, faCalendarAlt, faCamera, faCaretDown, faCaretLeft, faCaretRight, faCaretUp, faCertificate, faCheck, faCheckCircle, faCheckSquare, faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faCircle, faClipboardList, faClock, faCoffee, faComment, faCommentDots, faComments, faDollarSign, faDoorOpen, faDotCircle, faDownload, faEdit, faEnvelope, faExclamationCircle, faExclamationTriangle, faExpand, faExternalLinkAlt, faEye, faFile, faFileDownload, faFileExcel, faFilePdf, faFilePowerpoint, faFileUpload, faFileWord, faFilter, faFolder, faFolderOpen, faGraduationCap, faHome, faImage, faInfoCircle, faList, faListAlt, faLock, faMapMarkedAlt, faMapMarkerAlt, faMapSigns, faMedal, faPaperPlane, faPause, faPauseCircle, faPhone, faPlay, faPlayCircle, faPlus, faPlusCircle, faQuestion, faQuestionCircle, faQuoteLeft, faQuoteRight, faSearch, faShare, faShareAlt, faSignInAlt, faSort, faSortAmountDown, faSortAmountUp, faSortDown, faSortUp, faStar, faStreetView, faThumbsDown, faThumbsUp, faThumbtack, faTimes, faTimesCircle, faUpload, faUser, faUsers, faVideo, faVrCardboard } from '@fortawesome/free-solid-svg-icons'
import { faCheckCircle as faCheckCircleRegular } from '@fortawesome/free-regular-svg-icons'
import { faFacebook, faTwitter, faYoutube, faLinkedin, faInstagram } from '@fortawesome/free-brands-svg-icons'
import axios from 'axios'
import Glide from '@glidejs/glide'
import WebFont from 'webfontloader'
import tippy from 'tippy.js'
import Micromodal from 'micromodal'
import smoothscroll from 'smoothscroll-polyfill'
import dayjs from 'dayjs'
import stickyfill from 'stickyfilljs'
import tablesort from 'tablesort'
import AOS from 'aos'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import YouTubePlayer from 'youtube-player'
import Pristine from 'pristinejs'
import sha256 from 'crypto-js/sha256'
import accessibleAutocomplete from 'accessible-autocomplete'

/**
 * Import polyfills from utilities
 */
import Utilities from './helpers/utilities'
import SliderModule from './modules/sliderModule'
import AccordionModule from './modules/AccordionModule'
import NavigationModule from './modules/NavigationModule'
import AudienceModule from './modules/AudienceModule'
import UnitcodeModule from './modules/UnitcodeModule'
import TooltipModule from './modules/TooltipModule'
import ScrollToModule from './modules/ScrollToModule'
import DropdownModule from './modules/DropdownModule'
import EventModule from './modules/EventModule'
import SearchModule from './modules/SearchModule'
import ScrollspyModule from './modules/ScrollspyModule'
import StickyfillModule from './modules/StickyfillModule'
import ATARresultsModule from './modules/ATARresultsModule'
import AnimationsModule from './modules/AnimationsModule'
import HeaderModule from './modules/HeaderModule'
import CourselistingModule from './modules/CourselistingModule'
import YoutubeModule from './modules/YoutubeModule'
import LeadGenModule from './modules/LeadGenModule'
import ModalModule from './modules/ModalModule'
import NotificationModule from './modules/NotificationModule'
import SearchResultsModule from './modules/SearchResultsModule'
import GDPRModule from './modules/GDPRModule'
import MyUniStartModule from './modules/MyUniStartModule'
import TimeModule from './modules/TimeModule'
import DataRecordModalModule from './modules/DataRecordModalModule'
import EntryPathwayLeadGenModule from './modules/EntryPathwayLeadGenModule'
import EventFilterModule from './modules/EventFilterModule'
import ExperienceModule from './modules/ExperienceModule'
import AutocompleteModule from './modules/AutocompleteModule.js'
import UTMLeadsModule from './modules/UTMLeadsModule'

/**
 * Polyfill support for IE11 classList on SVG
 * https://www.npmjs.com/package/svg-classlist-polyfill
 */
import 'svg-classlist-polyfill'

loadFonts()
Utilities.polyfills()
smoothscroll.polyfill()

library.add(faAngleDoubleDown, faAngleDoubleLeft, faAngleDoubleRight, faAngleDoubleUp, faAngleDown, faAngleLeft, faAngleRight, faAngleUp, faArrowDown, faArrowLeft, faArrowRight, faArrowUp, faBars, faBell, faBook, faBookmark, faBookOpen, faBriefcase, faBuilding, faCalendar, faCalendarAlt, faCamera, faCaretDown, faCaretLeft, faCaretRight, faCaretUp, faCertificate, faCheck, faCheckCircle, faCheckCircleRegular, faCheckSquare, faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faCircle, faClipboardList, faClock, faCoffee, faComment, faCommentDots, faComments, faDollarSign, faDoorOpen, faDotCircle, faDownload, faEdit, faEnvelope, faExclamationCircle, faExclamationTriangle, faExpand, faExternalLinkAlt, faEye, faFacebook, faFile, faFileDownload, faFileExcel, faFilePdf, faFilePowerpoint, faFileUpload, faFileWord, faFilter, faFolder, faFolderOpen, faGraduationCap, faHome, faImage, faInfoCircle, faInstagram, faLinkedin, faList, faListAlt, faLock, faMapMarkedAlt, faMapMarkerAlt, faMapSigns, faMedal, faPaperPlane, faPause, faPauseCircle, faPhone, faPlay, faPlayCircle, faPlus, faPlusCircle, faQuestion, faQuestionCircle, faQuoteLeft, faQuoteRight, faSearch, faShare, faShareAlt, faSignInAlt, faSort, faSortAmountDown, faSortAmountUp, faSortDown, faSortUp, faStar, faStreetView, faThumbsDown, faThumbsUp, faThumbtack, faTimes, faTimesCircle, faTwitter, faUpload, faUser, faUsers, faVideo, faVrCardboard, faYoutube)

dom.watch()

/**
 * Test if running on local host as styleloader loads CSS after JS so we need to wait for everything to load before calling init to load JS
 */
if (document.location.href.includes('domain.local:')) {
  /**
   * @description Window onload event.
   *
   * @example //
   */
  window.onload = function () {
    init()
  }
} else {
  /**
   * DOM loaded event
   *
   * @event DOMContentLoaded
   * @type {object}
   */
  window.addEventListener('DOMContentLoaded', function () {
    init()
  })
}

/**
 *
 * @description Initialises all JS code
 *
 * @example //
 */
function init () {
  /**
   * Check dataLayer
   */
  window.dataLayer = window.dataLayer || []

  /**
   * Initialise sliders
   */
  var sliderModule = new SliderModule(Glide)
  sliderModule.init('.glide')

  try {
    /**
     * Initialise events
     */
    var eventModule = new EventModule(axios, SliderModule, Glide, dayjs)
    const eventPromise = eventModule.init()

    /**
     * Initialise Course list accordions
     */
    var courselistingModule = new CourselistingModule(axios)
    const courselistPromise = courselistingModule.init()

    /**
     * Initialise ATAR results
     */
    var atarresultsModule = new ATARresultsModule(axios, tablesort)
    const atarresultsPromise = atarresultsModule.init()

    try {
      Promise.all([eventPromise, courselistPromise, atarresultsPromise]).then((values) => {
        /**
         * Initialise scrollspy
         */
        if (document.querySelector('.myUniStart__body') === null) {
          var scrollspyModule = new ScrollspyModule()
          scrollspyModule.init()
        }
      })
    } catch (err) {
      console.error(err)
    }
  } catch (err) {
    console.error(err)
  }

  /**
   * Initialise accordions
   */
  var accordionModule = new AccordionModule()
  accordionModule.init()

  /**
   * Initialise navigation
   * Currently making sure nav exists before loading as certain page templates have no nav right now
   */

  if (document.querySelector('.siteNav') !== null) {
    var navigationModule = new NavigationModule(disableBodyScroll, enableBodyScroll, Utilities)
    navigationModule.initNavigation()
  }

  /**
   * Initialise audience toggles
   */
  var audienceModule = new AudienceModule()
  audienceModule.init()

  /**
   * Initialise modal windows
   */
  var unitcodeModule = new UnitcodeModule(axios, Micromodal)
  unitcodeModule.init()

  /**
   * Initialise tooltips
   */
  var tooltipModule = new TooltipModule(tippy, axios)
  tooltipModule.init()

  /**
   * Initialise anchor smooth scroll
   */
  if (document.querySelector('.myUniStart__body') === null && document.querySelector('.openDayPlanner') === null) {
    var scrollToModule = new ScrollToModule()
    scrollToModule.init()
  }

  /**
   * Initialise search module
   */
  var searchModule = new SearchModule(axios, accessibleAutocomplete, AutocompleteModule, disableBodyScroll, enableBodyScroll, Utilities)
  searchModule.init()

  /**
   * Initialise dropdowns
   */
  var dropdownModule = new DropdownModule()
  dropdownModule.init()

  /**
   * Initialise stickyfill
   */
  var stickyfillModule = new StickyfillModule(stickyfill, Utilities)
  stickyfillModule.init()

  /**
   * Initialise modals
   */
  var modalModule = new ModalModule(Micromodal)
  modalModule.init()

  /**
   * Initialise data record modals
   */
  var dataRecordModalModule = new DataRecordModalModule(Micromodal)
  dataRecordModalModule.init()

  /**
   * Initialise animations
   */
  var animationsModule = new AnimationsModule(AOS)
  animationsModule.init()

  /**
   * Initialise youtube player
   */
  var youtubeModule = new YoutubeModule(YouTubePlayer)
  youtubeModule.init()

  /*
   * Initialise leadgen form
   */
  var leadGenModule = new LeadGenModule(axios, Pristine, sha256)
  leadGenModule.init()

  var entryPathwayLeadGenModule = new EntryPathwayLeadGenModule(axios, Pristine)
  entryPathwayLeadGenModule.init()

  /**
   * Initialise header
   */
  if (document.querySelector('.header') !== null) {
    var headerModule = new HeaderModule()
    headerModule.init()
  }

  /**
   * Initialise Search Results Module
   */

  var searchResultsModule = new SearchResultsModule()
  searchResultsModule.init()

  /**
   * Notification Module
   */

  var notificationModule = new NotificationModule()
  notificationModule.init()

  /**
   * UTM Lead Module
   */

  var utmLeadsModule = new UTMLeadsModule()
  utmLeadsModule.init()

  const applyLinks = document.querySelectorAll('.apply-utms')

  utmLeadsModule.setUTM(applyLinks)

  /**
   * Initialise MyUniStart Module
   */
  if (document.querySelector('.myUniStart__body') !== null) {
    var myUniStartModule = new MyUniStartModule(disableBodyScroll, enableBodyScroll, Pristine, sha256, axios)
    myUniStartModule.init()
  }

  /**
   * Initialise EventsFilter Module
   */
  if (document.querySelector('[data-filters]') !== null) {
    var eventsFilterModule = new EventFilterModule()
    eventsFilterModule.init()
  }

  /**
   * Initialise Time Module if class of perth is found
   */
  if (document.querySelector('.perthTime') !== null) {
    var timeModule = new TimeModule()
    timeModule.init()
  }

  /**
   * Initialise World Ready Experience Module
   */

  var experienceModule = new ExperienceModule()
  experienceModule.init()

  /**
   * Wait for Krux to load in browser and then load GDPR banner
   */

  let kruxReady = async function () {
    while (typeof window.Krux === 'undefined') {
      await Utilities.delay(100)
    }

    var gdprModule = new GDPRModule()
    gdprModule.init()
  }
  kruxReady()

  let searchReady = async function () {
    let theTimeout = 0
    let allow = true
    let searchValue = ''
    let collections = ['ecu-web', 'ecu-fs-courses', 'ecu-web-staffdir', 'ecu-knowledge']

    while (document.querySelector('.searchForm') === null && theTimeout < 4) {
      // Increase timeout to stop the while if element never exists
      theTimeout++
      if (theTimeout === 4) {
        allow = false
      }
      await Utilities.delay(100)
    }

    if (allow) {
      if (document.querySelector('#query') != null) {
        document.querySelector('#query').value = ''
        document.querySelector('#query').remove()
        Utilities.delay(100).then(() => {
          document.querySelector('.searchForm').style = 'opacity: 1;'
        })
      }
      var autoComplete = new AutocompleteModule(axios, accessibleAutocomplete, Utilities)

      /**
       * Look for the current tab data attr and assign collections based on it
       */
      switch (document.querySelector('.searchForm').dataset.tab) {
        case 'Courses':
          collections = ['ecu-web', 'ecu-fs-courses']
          break
        case 'Staff':
          collections = ['ecu-web', 'ecu-web-staffdir']
          break
        case 'Ask Us':
          collections = ['ecu-web', 'ecu-knowledge']
          break
      }

      autoComplete.init({
        input: 'query',
        container: '.searchForm',
        value: searchValue,
        collections: collections,
        name: 'query'
      })
    }
  }
  searchReady()

  if (document.querySelector('.heroCourseSearch__form') !== null) {
    // Course search exists

    let courseCollection = ['ecu-web', 'ecu-fs-courses']
    let courseAutoComplete = new AutocompleteModule(axios, accessibleAutocomplete, Utilities)

    courseAutoComplete.init({
      input: 'heroSearch',
      container: '.heroCourseSearch__form',
      collections: courseCollection,
      name: 'query'
    })
  }
}

function loadFonts () {
  /**
   * Web font loader
   */
  WebFont.load({
    custom: {
      families: ['Integral CF:n7', 'Gilroy:n3,n4,i4,n7'],
      urls: ['//www.ecu.edu.au/__data/assets/css_file/0007/812617/fonts.css']
    }
  })
}
